'use client'

import { CalloutGuide } from '@/app/components/CalloutGuide'
import { SearchableArea } from '@/app/components/PageBuilder/SearchableArea'
import { TRACKING_LOCATIONS } from '@/app/utils/analytics'
import { AllGuidesQueryResult } from '@/sanity.types'

type Guide = AllGuidesQueryResult[number]

function searchGuides(guides: Guide[], query: string): Guide[] {
  const q = query.toLowerCase()
  return guides.filter(
    (guide) =>
      guide.title.toLowerCase().includes(q) || (guide.excerpt ?? '').toLowerCase().includes(q),
  )
}

function noGuideResults(query: string) {
  return (
    <p className="size-subheading-sm lg:size-subheading-md font-bold text-center text-neutral-900 my-5xl lg:my-7xl">
      Hmmm &hellip; no results for &ldquo;{query}&rdquo;, please try a different search.
    </p>
  )
}

function renderGuides(guides: Guide[]) {
  return (
    <div className="grid grid-cols-1 gap-2xl md:grid-cols-3 lg:gap-5xl mt-2xl lg:mt-5xl">
      {guides.map((guide) => (
        <CalloutGuide
          key={guide._id}
          guide={guide}
          tracking={{ location: TRACKING_LOCATIONS.PAGE_CONTENT }}
          showButton={false}
          bgColor="neutral-50"
          showOverline={false}
          wrapInLink={true}
          className="h-full"
        />
      ))}
    </div>
  )
}

type GuideAreaClientProps = {
  guideData: AllGuidesQueryResult
}

export function GuideAreaClient({ guideData }: GuideAreaClientProps) {
  return (
    <SearchableArea<Guide>
      items={guideData}
      searchFn={searchGuides}
      renderItems={renderGuides}
      noResultsFn={noGuideResults}
      searchPlaceholder="Search guides and topics"
    />
  )
}
